import { UPDATE_USER_LEAVEDATES } from '../constants/actionTypes';

export const addLeaveDatesToUpdate = (leaveDatesDataToUpdate) => ({
  type: UPDATE_USER_LEAVEDATES,
  leaveDatesDataToUpdate,
});
